/**
 |--------------------------------------------------------------------------
 | SALES / SERVICE : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const sales_service = [
 {
  path: '/all_pipelines', component: require('pages/sales_service/pipelines/all_pipelines').default,
  name: 'all_pipelines',
  meta: {requiresAuth: true, title: "All Pipelines", icon: "fas fa-funnel-dollar"}
 },
 {
  path: '/my_pipeline_overview', component: require('pages/sales_service/pipelines/my_pipeline_overview').default,
  name: 'my_pipeline_overview',
  meta: {requiresAuth: true, title: "My Pipeline Overview", icon: "fas fa-stream"}
 },
 {
  path: '/my_pipeline_detail', component: require('pages/sales_service/pipelines/my_pipeline_detail').default,
  name: 'my_pipeline_detail',
  meta: {requiresAuth: true, title: "My Pipeline Detail", icon: "fas fa-th-list"}
 },
];
export default sales_service;
